"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var ToastWrapper_1 = __importDefault(require("./styledComponents/ToastWrapper"));
var Toast_1 = __importDefault(require("../Toast"));
var Toaster_meta_1 = require("./Toaster.meta");
var Toaster = /** @class */ (function (_super) {
    __extends(Toaster, _super);
    function Toaster(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Toaster_meta_1.TOASTER_CATEGORY_KEY;
        _this.componentKey = Toaster_meta_1.TOASTER_COMPONENT_KEY;
        _this.timeouts = {};
        _this.items = [];
        _this.setupTimeout = function () {
            _this.items.forEach(function (item) {
                var toastId = item.toastId, displaySeconds = item.displaySeconds;
                if (displaySeconds && !_this.timeouts[toastId]) {
                    _this.timeouts[toastId] = setTimeout(function () {
                        _this.handleClose(toastId);
                    }, displaySeconds * 1000);
                }
            });
        };
        _this.handleClose = function (toastId) {
            _this.items = _this.items.filter(function (item) { return item.toastId !== toastId; });
            var onToastClose = _this.props.onToastClose;
            if (onToastClose) {
                onToastClose(toastId);
            }
        };
        if (props.items) {
            _this.items = props.items;
            _this.setupTimeout();
        }
        return _this;
    }
    Toaster.prototype.componentDidUpdate = function (previousProps) {
        var _a = previousProps.items, previousItems = _a === void 0 ? [] : _a;
        var _b = this.props.items, items = _b === void 0 ? [] : _b;
        var oldIds = previousItems.map(function (previousItem) { return previousItem.toastId; }).sort().join(',');
        var newIds = items.map(function (item) { return item.toastId; }).sort().join(',');
        if (typeof previousItems !== typeof items || previousItems.length !== items.length || newIds !== oldIds) {
            if (this.props.items) {
                this.items = this.props.items;
                this.setupTimeout();
            }
        }
    };
    Toaster.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        return (react_1.default.createElement(Wrapper_1.default, { className: className }, this.items.map(function (item) {
            var toastId = item.toastId;
            return (react_1.default.createElement(ToastWrapper_1.default, { key: toastId },
                react_1.default.createElement(Toast_1.default, __assign({}, item, { onClose: _this.handleClose }))));
        })));
    };
    __decorate([
        mobx_1.observable.ref
    ], Toaster.prototype, "items", void 0);
    __decorate([
        mobx_1.action
    ], Toaster.prototype, "handleClose", void 0);
    Toaster = __decorate([
        mobx_react_1.observer
    ], Toaster);
    return Toaster;
}(shared_1.ComponentBase));
exports.Toaster = Toaster;
exports.default = shared_1.InjectedStyledComponent(Toaster, Toaster_meta_1.TOASTER_CATEGORY_KEY, Toaster_meta_1.TOASTER_COMPONENT_KEY);
